import { useEffect, useState, useMemo } from 'react'
import { axiosInstance } from '../../../axiosInstance'

import { Table, Link, Loading, EditIcon } from '../../../components'

export function ProductTypesList() {
  const [productTypesData, setProductTypesData] = useState([])
  const [sorting, setSorting] = useState([])
  const [searchFilter, setSearchFilter] = useState('')
  const [totalRecords, setTotalRecords] = useState()
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })
  const [loading, setLoading] = useState(true)

  async function productTypesList(sorting, searchFilter, pagination) {
    const { id: sortingColumn = '', desc = false } = sorting[0] || []
    const sortingOrder = desc ? 'desc' : 'asc'
    await axiosInstance
      .post('product-types/list', {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        sort: [{ column: sortingColumn || 'product_types.name', order: sortingOrder }],
        search: searchFilter,
      })
      .then((res) => {
        setProductTypesData(res.data.results)
        setTotalRecords(res.data.resultCount)
      })
      .catch((err) => console.log(`Error: ${err.response.data}`))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    productTypesList(sorting, searchFilter, pagination)
  }, [sorting, searchFilter, pagination])

  useEffect(() => {
    setPagination({
      ...pagination,
      pageIndex: 0,
    })
  }, [sorting, searchFilter])

  const columns = useMemo(
    () => [
      {
        id: 'name',
        header: 'Name',
        accessorKey: 'name',
      },
      {
        id: 'Edit',
        accessorKey: 'name',
        header: 'Edit',
        cell: (info) => (
          <Link href={`${info.getValue()}`}>
            <EditIcon />
          </Link>
        ),
        enableSorting: false,
      },
    ],
    []
  )

  if (loading) return <Loading />

  return (
    <div>
      <div className="admin_list_page_header">
        <h1>Manage Product Types</h1>
        <Link href="create">Add New Product Type</Link>
      </div>
      <Table
        data={productTypesData}
        columns={columns}
        sorting={sorting}
        setSorting={setSorting}
        searchFilter={searchFilter}
        setSearchFilter={setSearchFilter}
        pagination={pagination}
        setPagination={setPagination}
        totalRecords={totalRecords}
      />
    </div>
  )
}
